export const Chats = api => ({
  list(cursor = null, search = null) {
    return api.get('/v1/chat-rooms', { params: { cursor, name: search } })
  },

  fetch(rooms) {
    return api.get('/v1/chat-rooms/fetch/rooms', { params: { rooms } })
  },

  messages: {
    list(chatRoom, isExtendedAccess = false, cursor = null) {
      return api.get(`/v1/chat-rooms/${chatRoom}/messages`, {
        params: {
          cursor: cursor || undefined,
          is_extended_access: isExtendedAccess || undefined
        },
        useStringifyParams: true,
        arrayFormat: 'repeat'
      })
    },

    send(chatRoom, payload) {
      return api.post(`/v1/chat-rooms/${chatRoom}/messages`, payload)
    },

    update(chatRoom, chatMessage, payload) {
      return api.put(`/v1/chat-rooms/${chatRoom}/messages/${chatMessage}`, payload)
    },

    delete(chatRoom, chatMessage) {
      return api.delete(`/v1/chat-rooms/${chatRoom}/messages/${chatMessage}`)
    },

    read(chatRoom, chatMessage) {
      return api.put(`/v1/chat-rooms/${chatRoom}/messages/${chatMessage}/read`)
    }
  }
})
